import {AuthApiService} from "base/api/service";
import ApiService from "../../api/service/ApiService";

const basePath = "/api/users/token/";
const userNotFoundMessage =
    "Utilizador não encontrado. Por favor, tente novamente ou contacte o seu administrador.";
const passwordNotCorrectMessage =
    "Senha incorrecta. Tente novamente ou contacte o administrador.";

const UserService = {
    fakeLogin(username, password) {
        return ApiService.get("/api/users").then(response => {
            console.log({response});
            var responseData = {
                type: "",
                message: "",
            };
            if (
                response.some(
                    user => user.username === username && user.password === password
                )
            ) {
                return true;
            } else if (
                response.some(
                    user => user.username === username && user.password !== password
                )
            ) {
                responseData.type = "passwordNotCorrect";
                responseData.message = passwordNotCorrectMessage;
                return responseData;
            }
            responseData.type = "userNotFound";
            responseData.message = userNotFoundMessage;
            return responseData;
        });
    },

    login(username, password) {
        return ApiService.post(basePath, {username, password}).then(response => {
            return response;
        });
    },

    refresh(refresh) {
        return ApiService.post(`${basePath}refresh/`, {refresh}).then(response => {
            return response;
        });
    },

    updateActiveIslands(id, payload) {
        return AuthApiService.put(`/api/users/users/${id}/`, payload);
    },

    changePassword(oldPassword, newPassword) {
        return AuthApiService.post("/api/users/change-password/", {
            old_password: oldPassword,
            new_password: newPassword,
        });
    },
};

export default UserService;
